class ProductAddon extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.getAttribute('data-variant-id');
    this.cartItemCount = this.getAttribute('data-cart-count');

    this.addEventListener('click', this.handleAddToCart.bind(this));
  }

  connectedCallback() {}

  disconnectedCallback() {
    this.removeEventListener('click', this.handleAddToCart.bind(this));
  }

  async handleAddToCart() {
    if (document.querySelector(".cart-item")) {
      try {
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) throw new Error('Failed to fetch cart data.');

        const cart = await cartResponse.json();
        const itemInCart = cart.items.find(item => item.id === parseInt(this.variantId));
        this.showSpinner();
        if (itemInCart && itemInCart.quantity >= 1) {
          this.showMessage("You can't add more than 1 item.");
          setTimeout(()=>{
            this.hideSpinner();
          },500)
          return;
        }

        let formData = {
          items: [{ id: this.variantId, quantity: 1 }]
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        });

        if (!response.ok) throw new Error('Network response was not ok.');

        setTimeout(() => this.hideSpinner(), 1000);
        this.updateDrawer();

      } catch (error) {
        console.error('Error adding item to cart:', error);
        this.showMessage('Error adding item to cart.');
      }
    } else {
      this.showMessage('To get a free item, add at least one item to the cart.');
    }
  }

  showMessage(message) {
    const messageElement = document.querySelector('.free__addon__text__messege');
    messageElement.innerHTML = message;
    messageElement.classList.remove('hide');
    setTimeout(() => messageElement.classList.add('hide'), 1500);
  }

  showSpinner() {
    const spinner = this.querySelector('.loading__spinner');
    spinner?.classList.remove('hidden');
    console.log(this,"product-addon-wrapper")
  }

  hideSpinner() {
    const spinner = this.querySelector('.loading__spinner');
    spinner?.classList.add('hidden');
  }

  async updateDrawer() {
    const cartDrawers = document.querySelector('cart-drawer');
    const cartItemsContainer = document.querySelector('cart-drawer-items #CartDrawer-CartItems');

    try {
      const response = await fetch('/cart');
      if (!response.ok) throw new Error('Network response was not ok.');

      const htmlText = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const cartItems = doc.querySelectorAll('.cart-drawer table');
      const footerUpdate = doc.querySelector(".drawer__footer");

      cartItemsContainer.innerHTML = '';

      cartItems.forEach(item => {
        const clonedItem = item.cloneNode(true);
        cartItemsContainer.appendChild(clonedItem);
      });

      if (footerUpdate) {
        document.querySelector(".drawer__footer").innerHTML = footerUpdate.innerHTML;
      }

      this.toggleCartDrawer(cartItems.length > 0);
      cartDrawers.classList.add('active');

    } catch (error) {
      console.error('Error fetching cart HTML:', error);
      this.showMessage('Error updating cart drawer.');
    }
  }

  toggleCartDrawer(hasItems) {
    const cartDrawerForm = document.querySelector('form#CartDrawer-Form');
    const emptyContent = document.querySelector('.cart-drawer__empty-content');
    const drawerHeader = document.querySelector('.drawer__header');

    cartDrawerForm.style.display = hasItems ? 'block' : 'none';
    if (emptyContent) emptyContent.style.display = hasItems ? 'none' : 'block';
    drawerHeader.style.display = hasItems ? 'block' : 'none';

    if (hasItems) {
      document.querySelector("cart-drawer-items").classList.remove("is-empty");
      document.querySelector("cart-drawer").classList.remove("is-empty");
    } else {
      document.querySelector("cart-drawer-items").classList.add("is-empty");
      document.querySelector("cart-drawer").classList.add("is-empty");
    }
  }
}

customElements.define('product-addon', ProductAddon);
